import {
  GET_DASHBOARD_PLAYER_DETAILS_LOADING,
  GET_DASHBOARD_PLAYER_DETAILS_SUCCESS,
  GET_DASHBOARD_PLAYER_DETAILS_ERROR,
  USER_ROLE,
} from "./../../../constant/actionTypes";

const userDetailsReducer = (
  state = { loading: true, role: "player" },
  action
) => {
  switch (action.type) {
    case GET_DASHBOARD_PLAYER_DETAILS_LOADING: {
      let obj = {
        ...state,
        loading: true,
      };
      return obj;
    }
    case GET_DASHBOARD_PLAYER_DETAILS_SUCCESS: {
      let obj = {
        ...state,

        loading: false,
        data: action.response.data,
      };
      return obj;
    }
    case GET_DASHBOARD_PLAYER_DETAILS_ERROR: {
      let obj = {
        ...state,
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case USER_ROLE: {
      let obj = {
        ...state,
        loading: false,
        role: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};
export default userDetailsReducer;
